import { render, staticRenderFns } from "./CandidateProfessionalData.vue?vue&type=template&id=c5abdc8c&scoped=true"
import script from "./CandidateProfessionalData.vue?vue&type=script&lang=js"
export * from "./CandidateProfessionalData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5abdc8c",
  null
  
)

export default component.exports